import { IntlShape } from 'react-intl';

export const dictionary = {
    // PageContent
    page_content__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.page-content.f4f70727dc34561dfde1a3c529b6205c',
            defaultMessage: 'Settings',
            description: 'Заголовок страницы настроек',
        }),
    watching_section__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.page-content.3627fc6c218d0a88700f606bf24b0d77',
            defaultMessage: 'Watching',
            description: 'Заголовок секции настроек просмотра',
        }),
    general_section__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.page-content.0db377921f4ce762c62526131097968f',
            defaultMessage: 'General',
            description: 'Группа общих настроек, включающая в себя язык интерфейса',
        }),
    subscription_section__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.page-content.787ad0b7a17de4ad6b1711bbf8d79fcb',
            defaultMessage: 'Subscription',
            description: 'Заголовок секции настроек подписки',
        }),

    // AudioLanguageSetting
    audio_language__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.audio-language-setting.1e046db7a4665500f7097a3ab658284a',
            defaultMessage: 'Audio language',
            description: 'Заголовок настройки языка аудиодорожки по умолчанию',
        }),
    audio_language__description: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.audio-language-setting.c777c26eb9a0a96d1f793e7e89491358',
            defaultMessage: 'Will play if available',
            description: 'Описание настройки языка аудиодорожки',
        }),
    audio_language__dropdown_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.audio-language-setting.a8d69cdfad4c19ed22bf693b8871064e',
            defaultMessage: 'Choose language',
            description: 'Текст кнопки выбора языка аудиодорожки',
        }),

    // DisplayLanguageSetting
    display_language__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.display-language-setting.b5e4a71c2db71f5e2a42c43b02f39657',
            defaultMessage: 'Interface language',
            description: 'Заголовок настройки языка приложения',
        }),
    display_language__description: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.display-language-setting.b9e8f6b11d01c1a6e8b77f95adddaf35',
            defaultMessage: 'This will change the text language in the app',
            description: 'Описание настройки языка интерфейса',
        }),
    display_language__dropdown_title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.display-language-setting.a8d69cdfad4c19ed22bf693b8871064e',
            defaultMessage: 'Choose language',
            description: 'Текст селекта выбора языка интерфейса',
        }),

    // SubscriptionSettings
    subscription_settings__title: (intl: IntlShape) =>
        intl.formatMessage({
            id: 'pages.settings.ui.subscription-settings.97788cfaf9dabfbe68578f0e5a637b5e',
            defaultMessage: 'Manage subscription',
            description: 'Заголовок настройки "Управление подпиской"',
        }),
};
